/**
 * Apply functionality that simplifies the process of defining a custom element
 * with a namespace. Namespacing a custom element is required for multiple
 * versions of the element to exist within the same page because the
 * CustomElementRegistry does not support versioning.
 *
 * @remarks
 * Must be applied to a class that extends LitElement.
 */
export default function customElement(options) {
    return function customElementMixin(base) {
        return class CustomElementMixinClass extends base {
            /**
             * Define the custom element within the CustomElementRegistry by combining
             * the value of `namespace` with the `componentName` property
             *
             * @param namespace - a string that will prefix the custom element's name (e.g., `${namespace}-component-name`)
             */
            static defineCustomElement(namespace = options.namespace) {
                this.namespace = namespace;
                const customElementName = `${namespace}-${options.name}`;
                if (!customElements.get(customElementName)) {
                    customElements.define(customElementName, this);
                }
            }
            /**
             * Invoked by LitElement to determine where the template should render
             *
             * @see
             * https://lit-element.polymer-project.org/guide/templates#renderroot
             */
            createRenderRoot() {
                if (options.shadowDOM === undefined || options.shadowDOM) {
                    return super.createRenderRoot();
                }
                return this;
            }
        };
    };
}
//# sourceMappingURL=custom-element.js.map